// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tb-navbar {
    list-style-type: none;
    background-color: #000;
    margin: 5px 0;
    padding: 0;
    user-select: none;
}

.tb-navbar-toggle {
    color: #ccc;
    font-size: 2em;
}

.tb-navbar-toggle-restore {
    font-size: 0.5em;
}

.tb-navbar-list {
    position: absolute;
    display: flex;
    flex-direction: column;
    background-color: #000;
    padding: 10px 0;
    z-index: 1;
    border-top: 1px solid red;
    border-bottom: 1px solid red;
}

.tb-navbar-list-position-top {
    position: absolute;
}

.tb-navbar-list-position-right {
    position: absolute;
    top: -10px;
    left: calc(100% - 5px);
}

.tb-navbar-list-position-left {
    position: absolute;
    top: -10px;
    right: calc(100% - 5px);
}

.tb-navbar-list-position-below {
    position: absolute;
    left: 30px;
}

.tb-navbar-logo {
    display: inline-block;
    cursor: default;
}

.tb-navbar-item {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    color: #ccc;
    padding: 5px 10px;
    text-decoration: none;
    cursor: pointer;
}

.tb-navbar-text {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    color: #ccc;
    padding: 5px 10px;
    text-decoration: none;
    cursor: default;
}

@media (hover:hover) and (pointer: fine) {
    .tb-navbar-item:hover {
        color: red;
    }
}

.tb-navbar-disabled-item {
    display: inline-block;
    white-space: nowrap;
    color: #444;
    padding: 5px 10px;
    text-decoration: none;
    cursor: default;
}

.tb-navbar > .tb-navbar-item {
    padding: 12px 10px;
}

.tb-navbar-divider {
    position: relative;
    left: 30px;
    width: calc(100% - 60px);
    border-top: 1px solid red;
}

.tb-navbar-list-icon-color {
    color: #880;
}

.tb-navbar-link-icon-color {
    color: #080;
}

.tb-navbar-back-icon-color {
    color: #088;
}

.tb-navbar-disabled-icon-color {
    color: #800;
}

.tb-navbar-text-icon-color {
    color: #800;
}
`, "",{"version":3,"sources":["webpack://./src/components/navBar/NavBar.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["\r\n.tb-navbar {\r\n    list-style-type: none;\r\n    background-color: #000;\r\n    margin: 5px 0;\r\n    padding: 0;\r\n    user-select: none;\r\n}\r\n\r\n.tb-navbar-toggle {\r\n    color: #ccc;\r\n    font-size: 2em;\r\n}\r\n\r\n.tb-navbar-toggle-restore {\r\n    font-size: 0.5em;\r\n}\r\n\r\n.tb-navbar-list {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #000;\r\n    padding: 10px 0;\r\n    z-index: 1;\r\n    border-top: 1px solid red;\r\n    border-bottom: 1px solid red;\r\n}\r\n\r\n.tb-navbar-list-position-top {\r\n    position: absolute;\r\n}\r\n\r\n.tb-navbar-list-position-right {\r\n    position: absolute;\r\n    top: -10px;\r\n    left: calc(100% - 5px);\r\n}\r\n\r\n.tb-navbar-list-position-left {\r\n    position: absolute;\r\n    top: -10px;\r\n    right: calc(100% - 5px);\r\n}\r\n\r\n.tb-navbar-list-position-below {\r\n    position: absolute;\r\n    left: 30px;\r\n}\r\n\r\n.tb-navbar-logo {\r\n    display: inline-block;\r\n    cursor: default;\r\n}\r\n\r\n.tb-navbar-item {\r\n    position: relative;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    color: #ccc;\r\n    padding: 5px 10px;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.tb-navbar-text {\r\n    position: relative;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    color: #ccc;\r\n    padding: 5px 10px;\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n@media (hover:hover) and (pointer: fine) {\r\n    .tb-navbar-item:hover {\r\n        color: red;\r\n    }\r\n}\r\n\r\n.tb-navbar-disabled-item {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    color: #444;\r\n    padding: 5px 10px;\r\n    text-decoration: none;\r\n    cursor: default;\r\n}\r\n\r\n.tb-navbar > .tb-navbar-item {\r\n    padding: 12px 10px;\r\n}\r\n\r\n.tb-navbar-divider {\r\n    position: relative;\r\n    left: 30px;\r\n    width: calc(100% - 60px);\r\n    border-top: 1px solid red;\r\n}\r\n\r\n.tb-navbar-list-icon-color {\r\n    color: #880;\r\n}\r\n\r\n.tb-navbar-link-icon-color {\r\n    color: #080;\r\n}\r\n\r\n.tb-navbar-back-icon-color {\r\n    color: #088;\r\n}\r\n\r\n.tb-navbar-disabled-icon-color {\r\n    color: #800;\r\n}\r\n\r\n.tb-navbar-text-icon-color {\r\n    color: #800;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
